import { useState } from "react"

import { Card } from "components"
import { useGet, usePersistForm } from "hooks"
import { FormProvider, useForm } from "react-hook-form"
import { IPaginatedEntityGST } from "services/core/genericEntityGST"
import { IGetWithFiltersParams, IGetWithFiltersResponse } from "services/GST/Parameterization"
import { FORMAT, FUNCTIONS, SPACING } from "utils"

import FiltersJobs from "../SerachFiltersJobs/FiltersJobs"
import { IForm } from "../types"
import TableConsultaJobs from "./components/tableConsultaJobs"
import moment from "moment"

const TableConsultaJobsComponent: React.FC = () => {
    const methods = useForm<IForm>({
        defaultValues: {
            txTipoContexto: 'GST'
        }
    })

    usePersistForm('gst-consult-jobs-form', {
        setValue: methods.setValue,
        watch: methods.watch
    })
    const params : IGetWithFiltersParams= {
        ...FUNCTIONS.filterObject(methods.getValues(), Boolean),
    };

    if (params.DtEnvioInicio && moment.isMoment(params.DtEnvioInicio)) {
        params.DtEnvioInicio = params.DtEnvioInicio.toISOString();
    }
    if (params.DtEnvioFim && moment.isMoment(params.DtEnvioFim)) {
        params.DtEnvioFim = params.DtEnvioFim.toISOString();
    }

    const [tipos, setTipos] = useState([])
    const {
        data,
        refresh: refreshTable,
        page,
        rowsPerPage,
        handleChangeRowsPerPage,
        handleChangePage
        
    } = useGet<IGetWithFiltersParams, IPaginatedEntityGST<IGetWithFiltersResponse[]>>({
        api: 'Read',
        isPaginated: true,
        params,
        url: 'LogEmailJob/GetWithFilters'
    })

    const handleSubmitForm = (data: IForm) => {
        const { DtEnvioInicio, DtEnvioFim } = data
        const formatedObj: IForm = {
            ...data,
            txTipoContexto: 'GST',
            ...FORMAT.dateIfExists({ DtEnvioFim, DtEnvioInicio }),
        }
        refreshTable({ ...FUNCTIONS.filterObject(formatedObj, Boolean) })
    }

    return (
        <FormProvider {...methods}>
            <Card
                marginLeft={SPACING.spacing20}
                marginRight={SPACING.spacing20}
                marginBottom={SPACING.spacing100}
                padding={SPACING.spacing20}
                boxShadow={`0px -1px 32px rgba(50, 50, 71, 0.12), 0px 24px 32px rgba(50, 50, 71, 0.12)`}
                borderRadius={`0px 10px 0px 0px`}
            >
                {tipos && (
                    <FiltersJobs
                        refreshTable={refreshTable}
                        setTipos={setTipos}
                        handleSubmitForm={handleSubmitForm}
                        tipos={tipos}
                    />
                )}
                <TableConsultaJobs
                    tableData={data}
                    page={page}
                    rowsPerPage={rowsPerPage}
                    handleChangeRowsPerPage={handleChangeRowsPerPage}
                    handleChangePage={handleChangePage}
                />
            </Card>
        </FormProvider>
    )
}

export default TableConsultaJobsComponent